import { CONTACT_API } from 'modules/contacts/api/contact-api'

export const CONTACTS_IMPORT_API = `${CONTACT_API}/contacts/import`
